"use client"

import Link from "next/link"
import { Typography } from "@/components/typography"
import { Button } from "@/components/ui/button"
import { BrokenCode } from "@/components/illustrations/BrokenCode"

export default function NotFound() {
  return (
    <div
      className="bg-tk-linen text-tk-slate flex items-center justify-center px-6 py-12"
      style={{ minHeight: "100vh", maxHeight: "100dvh" }}
    >
      <div className="max-w-2xl w-full flex flex-col items-center text-center space-y-6 md:space-y-8 px-4">
        <div className="w-full max-w-[160px] md:max-w-[240px] aspect-square flex items-center justify-center flex-shrink-0 p-4">
          <BrokenCode className="w-full h-full" />
        </div>

        <div className="not-found-rise space-y-4">
          <Typography variant="eyebrow" className="text-tk-slate/70">
            Oops!
          </Typography>
          <Typography variant="h1" as="h1">
            This page doesn&apos;t exist
          </Typography>
          <Typography variant="body" className="text-tk-slate/80 max-w-xl mx-auto">
            Looks like you wandered off the main path. Let&apos;s get you back to where the real work happens.
          </Typography>
        </div>

        <div className="not-found-rise not-found-rise-delay flex flex-wrap items-center justify-center gap-3 pt-2">
          <Button
            asChild
            className="rounded-full bg-tk-teal px-6 py-2 text-sm font-semibold text-tk-linen hover:bg-tk-teal/90 font-ui"
          >
            <Link href="/">Go Home</Link>
          </Button>
          <Button
            asChild
            variant="outline"
            className="rounded-full border-tk-slate/25 bg-tk-linen text-sm text-tk-slate hover:border-tk-teal hover:text-tk-onyx font-ui"
          >
            <Link href="/services">View Services</Link>
          </Button>
          <Button
            asChild
            variant="outline"
            className="rounded-full border-tk-slate/25 bg-tk-linen text-sm text-tk-slate hover:border-tk-teal hover:text-tk-onyx font-ui"
          >
            <Link href="/contact">Get In Touch</Link>
          </Button>
        </div>
      </div>
    </div>
  )
}
